// src/app/ip.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpService {

  private apiUrl = 'https://api.ipify.org?format=json';

  constructor(private http: HttpClient) { }

  getIpAddress(): Observable<any> {
    return this.http.get(this.apiUrl);
  }
  getTest():any{
    this.http.get<{ip:string}>('https://jsonip.com')
    .subscribe( data => {
      console.log('th data', data);
      // this.ipAddress = data
    })
  }
  getIPAddress():Observable<any>{
    const url = `https://jsonip.com`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.value) // Extract and return the 'value' array
    );
  }
  async getIP(): Promise<string> {
    try {
        const response = await fetch('https://jsonip.com');
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Failed to fetch IP:', error);
        throw error;
    }
}
}
